import React, { Fragment } from "react";
import { Card, Col, Button } from 'react-bootstrap';
import '../../../../../../styles/diario.scss';

const Remume = (props) => {


    const deletar = async (id) => {
        props.deletar(id)
        await props.fetchRemumes()
    }

    const editar = async (id) => {
        props.editar(id)
    }

    return (
        <Fragment>
            <Col>
                <Card className='card-list'>
                    <Card.Body>
                        <Card.Title className="cabeca-card" key={props.key}>{props.remume.nome}</Card.Title>
                        <p>Concentração/Composição: {props.remume.composicao}</p>
                        <p>Apresentação: {props.remume.apresentacao}</p>
                        <p>Disponibilidade: {props.remume.disponibilidade}</p>
                    </Card.Body>
                    <hr />
                    <Button type="button" className="botao-leis" onClick={() => editar(props.remume._id)} variant='primary'>Editar</Button>
                    <Button type='button' className="botao-leis" onClick={() => deletar(props.remume._id)} variant='danger'>Excluir</Button>
                </Card>
            </Col>
        </Fragment >)
}

export default Remume;